<ion-grid class="ion-no-padding">
    <ion-row>
        <ion-col>
            <ion-item lines="none">
                <ion-label style="white-space:pre-wrap">
                    <a [href]="props.url" class="underline" target="_blank">{{props.label}}</a>&nbsp;{{secondLabel}}
                </ion-label>
            </ion-item>
        </ion-col>
        <ion-col>
            <ion-item lines="none" class="custom-checkbox">
                <ion-checkbox color="primary" slot="end" [formControl]="formControl" [value]="props.value"
                    [required]="props.required"></ion-checkbox>
            </ion-item>
        </ion-col>
    </ion-row>
</ion-grid>
